import axios from "axios";

const instance = axios.create({
  // baseURL: "http://192.168.100.87:3000",
  // baseURL: 'http://localhost:3000',
  baseURL: "https://ec2-52-221-63-144.ap-southeast-1.compute.amazonaws.com",
});

export default instance;
